import request from '@/utils/request'
import base from "@/api/base";

export default {
    //新增面料信息
    add: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/saveBaseProduct`, params),
    //查询面料信息列表
    get: params => request.get(`${base.baseUrl}/yyyhao-cloud-product/product/getBaseProductList?${params}`),
    //修改面料信息
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/updateBaseProduct`, params),
    //删除面料信息
    del: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/deleteBaseProduct`, params),

}